const Bars = ({ title, items, color, testId }) => (
  <div className="bg-[#F4EFE6] border border-[#E2D9CC] p-8" data-testid={testId}>
    <h3 className="font-display text-2xl text-[var(--g-dark,#3B1B48)] mb-6">{title}</h3>
    {items?.map((r) => (
      <div key={r.label} className="mb-5">
        <div className="flex justify-between text-sm"><span>{r.label}</span><span className="font-display text-[var(--g-dark,#3B1B48)]">{r.score}/10</span></div>
        <div className="h-2 bg-[#E2D9CC] my-1.5"><div className="h-full transition-[width] duration-700" style={{ width: `${r.score * 10}%`, background: color }} /></div>
        <p className="text-xs italic text-[#8C827A]">{r.note}</p>
      </div>
    ))}
  </div>
);

export const RatingsPanel = ({ c }) => (
  <div className="space-y-8">
    <div className="flex flex-wrap items-end gap-10">
      <div>
        <p className="eyebrow">Overall score</p>
        <p data-testid="overall-score" className="font-display text-7xl text-[var(--g-dark,#3B1B48)]">{c.overall_score}<span className="text-2xl text-[#8C827A]">/10</span></p>
      </div>
      <div className="flex-1 min-w-[280px] border border-[var(--g-dark,#3B1B48)] p-6">
        <p className="eyebrow !text-[var(--g-dark,#3B1B48)] mb-2">The one catch</p>
        <p className="font-display italic text-lg text-[#1C181D]">{c.the_catch}</p>
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <Bars title="The Expat Rating" items={c.expat_rating} color="var(--g-dark,#3B1B48)" testId="expat-rating" />
      <Bars title="The Liveability Rating" items={c.liveability_rating} color="var(--g-accent,#C59B27)" testId="liveability-rating" />
    </div>
    <div className="bg-[#F4EFE6] border border-[#E2D9CC] p-8">
      <h3 className="font-display text-2xl text-[var(--g-dark,#3B1B48)] mb-6">At a glance</h3>
      <dl className="grid sm:grid-cols-2 gap-x-10">
        {c.at_a_glance?.map((f) => (
          <div key={f.label} className="flex justify-between gap-4 py-3 border-b border-[#E2D9CC] text-sm">
            <dt className="eyebrow !text-[#8C827A]">{f.label}</dt><dd className="text-right">{f.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  </div>
);
